<div id="app-notification-modal-div">

  <div class="sub-header">
    <app-shared-custom-select
      (selectionChange)="onStoreSelectionChange($event)"
      [allowMultiple]="true"
      [placeholder]="'Select Stores'"
      [selected]="selectedStores"
      [setOptions]="getStoresAsISelectOptions()"
      [showChips]="true">
    </app-shared-custom-select>
  </div>

  <div class="filter-chips">
    <div class="switches">
      <div class="switch-container">
        <div>Unread ({{ notifications.unread }})</div>
        <app-switch-ui
          (checkedChange)="onToggleClick($event, 'UNREAD')"
          [ariaLabel]="'all-notifications'"
          [checked]="!notificationChips.allMessages"
          [disabled]="!(notifications.unread > 0)"
          [size]="0.6">
        </app-switch-ui>
      </div>

      <div class="switch-container">
        <div>Failed ({{ filteredFailedCount }})</div>
        <app-switch-ui
          (checkedChange)="onToggleClick($event, 'FAIL')"
          [ariaLabel]="'all-fail'"
          [checked]="notificationChips.fail"
          [disabled]="!(filteredFailedCount > 0)"
          [size]="0.6">
        </app-switch-ui>
      </div>
    </div>

    <div class="notification-type-filter">
      <app-shared-custom-select
        (selectionChange)="onNotificationTypeSelectionChange($event)"
        [allowMultiple]="true"
        [allowSelectAll]="true"
        [placeholder]="'Notification Types'"
        [setOptions]="getNotificationTypesAsISelectOptions()"
        [showActionButtons]="true"
        [showChips]="false"
        [showSearchBar]="false">
      </app-shared-custom-select>
    </div>

  </div>

  <div class="accordion-container">

    <app-shared-scrolling
      (scrolledToThreshold)="getIsUserScrollLoading === false && !pageRequested && lastNotificationDocumentId != null ? onScrollTrigger() : null"
      [enableAutoFillWhenShort]="enableScrollAutoFillWhenShort"
      [idProperty]="'notificationId'"
      [isScrollDataLoading]="isUserScrollLoading || pageRequested"
      [itemTemplate]="notificationAccordionItem"
      [scrollData]="scrollData"
      [scrollDataRevision]="scrollDataRevision"
      [threshold]="200">
      <div class="noData" noData>No Notifications Found, please select other stores or update your filters</div>
    </app-shared-scrolling>

    <ng-template #notificationAccordionItem let-notify>
      <app-shared-accordion-item
        (accordionHeaderClicked)="selectNotification($event, notify)"
        [canToggle]="notify.notificationId !== 'loading'"
        [isOpen]="isAccordionOpen[notify?.notificationId] ?? false"
        [ngClass]="{
          'notification-read': notify?.read?.length > 0,
          'notification-unread': !(notify?.read?.length > 0),
        }">

        <div class="header">

          @if (isMobile) {
            <div appHorizontalScroll class="scroll-div">
              <ng-container *ngTemplateOutlet="headerContent"></ng-container>
            </div>
          } @else {
            <div class="scroll-div">
              <ng-container *ngTemplateOutlet="headerContent"></ng-container>
            </div>
          }


          <ng-template #headerContent>
            @if (notify.type === notificationTypesEnum.LOADING && getIsUserScrollLoading) {
              <div class="notification-card notification-card-loading" aria-hidden="true">
                <div class="card-icon shimmer-block"></div>
                <div class="card-copy">
                  <div class="shimmer-block shimmer-title"></div>
                  <div class="shimmer-block shimmer-line"></div>
                  <div class="shimmer-block shimmer-meta"></div>
                </div>
              </div>
            } @else {
              <div
                class="notification-card"
                [class.notification-card-failed]="!notify.success && !notify.reverted"
                [class.notification-card-unread]="!(notify?.read?.length > 0)">
                <div
                  class="card-icon"
                  [class.card-icon-success]="notify.success || notify.reverted"
                  [class.card-icon-failed]="!notify.success && !notify.reverted">
                  <app-display-icon
                    [border]="false"
                    [colour]="getCardIconColour(notify)"
                    [icon]="getCardIcon(notify)">
                  </app-display-icon>
                </div>

                <div class="card-copy">
                  <div class="card-title-row">
                    <span class="card-title" [title]="notify.event">{{ getCardTitle(notify) }}</span>
                    <span
                      class="status-pill"
                      [class.status-pill-success]="notify.success && !notify.reverted"
                      [class.status-pill-failed]="!notify.success && !notify.reverted && !notify.retried"
                      [class.status-pill-retried]="notify.retried && !notify.success"
                      [class.status-pill-reverted]="notify.reverted">
                      {{ getStatusLabel(notify) }}
                    </span>
                  </div>
                  <div class="card-meta">
                    <span class="store-chip">
                      <app-display-icon
                        [border]="false"
                        [colour]="iconColourEnum.secondary"
                        [icon]="icons.storeOutline">
                      </app-display-icon>
                      {{ getStoreChip(notify) }}
                    </span>
                    <span
                      class="card-time"
                      [attr.title]="firebaseTimeStampToDate(notify.timestamp) | date:'d MMM y, HH:mm'">
                      <app-display-icon
                        [border]="false"
                        [colour]="iconColourEnum.secondary"
                        [icon]="icons.clock">
                      </app-display-icon>
                      {{ getTimeAgo(firebaseTimeStampToDate(notify.timestamp)) }}
                    </span>
                  </div>
                </div>

                <app-display-icon
                  class="card-chevron"
                  [class.card-chevron-open]="isAccordionOpen[notify?.notificationId]"
                  [border]="false"
                  [colour]="iconColourEnum.secondary"
                  [icon]="icons.chevronDown">
                </app-display-icon>
              </div>
            }
          </ng-template>

        </div>

        <div class="body">
          @if (notify.notificationId !== 'loading') {
            <app-notification-container
              [setNotification]="notify"
              [setUserStores]="getUserStores"
              [setUser]="user">
            </app-notification-container>
          }
        </div>

      </app-shared-accordion-item>
    </ng-template>

  </div>

</div>
